import { Timestamp } from 'firebase/firestore';
import { Patient } from '../../../domain/entities';
import { FirebasePatient } from '../entities';

export class PatientMapper {
  static toDomain(firebasePatient: FirebasePatient): Patient {
    return new Patient({ ...firebasePatient, birthDate: firebasePatient.birthDate.toDate() });
  }

  static toFirebaseDomain(patient: Patient): FirebasePatient {
    const firebasePatient: FirebasePatient = {
      address: patient.address,
      birthDate: Timestamp.fromDate(patient.birthDate),
      cellphone: patient.cellphone,
      city: patient.city,
      civilStatus: patient.civilStatus,
      email: patient.email,
      gender: patient.gender,
      name: patient.name,
      phone: patient.phone,
      ssn: patient.ssn,
      state: patient.state
    };
    if (patient.id) firebasePatient.id = patient.id;

    return firebasePatient;
  }
}
